import { Localization } from '../../../localization/localization';

export enum RegistrationErrorCode {
    WRONG_OTP = 9,
    NOT_REGISTERED = 17,
    TOO_MANY_REQUESTS = 429,
    WRONG_EMAIL = 16,
    EMAIL_EXISTS = 18,
    BAD_REQUEST = 400
}

// Codes that carry their own message for the user, so they stay out of Sentry.
// BAD_REQUEST is absent on purpose: it means the payload was wrong, which is ours.
export function isExpectedRegistrationError(errorCode: number): boolean {
    return [
        RegistrationErrorCode.WRONG_OTP,
        RegistrationErrorCode.WRONG_EMAIL,
        RegistrationErrorCode.EMAIL_EXISTS,
        RegistrationErrorCode.TOO_MANY_REQUESTS
    ].includes(errorCode);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getErrorMessage(errorCode: number, errorData: any): string {
    let msg: string;
    switch (errorCode) {
        case RegistrationErrorCode.WRONG_EMAIL:
            msg = 'errors.email_wrong';
            break;
        case RegistrationErrorCode.EMAIL_EXISTS:
            msg = 'errors.already_reg';
            break;
        case RegistrationErrorCode.WRONG_OTP:
            msg = 'otp_request_code.not_full';
            break;
        case RegistrationErrorCode.BAD_REQUEST:
            msg = errorData?.error ?? 'errors.common_error';
            break;
        case RegistrationErrorCode.TOO_MANY_REQUESTS:
            // errors.too_many_requests is a login-lockout text, and is not in the bundle.
            msg = 'otp_request_code.wait_30';
            break;
        case RegistrationErrorCode.NOT_REGISTERED:
        default:
            msg = 'errors.common_error';
    }

    return Localization._n(msg);
}
